import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

const CRes = (props) => {
  useLayoutEffect(() => {
    document.head.innerHTML = '';
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Type';
    meta.content = 'application/json; charset=UTF-8';
    document.head.appendChild(meta);
  }, []);

  const [submitted, setSubmitted] = useState(null);

  const submitForm = (form) => {
    if (!form) return;
    if (!submitted) {
      setSubmitted(true);
      form.submit();
    }
  };

  const {
    url, response, threeDSSessionData,
  } = props;
  return (
    <form name="mainform" method="POST" action={url} ref={submitForm}>
      <div style={{ display: 'none' }}>
        Transaction Successful...
        <input type="hidden" id="cres" name="cres" value={response} />
        <input
          type="hidden"
          id="threeDSSessionData"
          name="threeDSSessionData"
          value={threeDSSessionData || ''}
        />
      </div>
    </form>
  );
};

CRes.propTypes = {
  url: PropTypes.string.isRequired,
  response: PropTypes.string.isRequired,
  threeDSSessionData: PropTypes.string.isRequired,
};

export default CRes;
